var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginLayout',{scopedSlots:_vm._u([{key:"container",fn:function(){return [_c('LoginContainer',{attrs:{"title":_vm.$t('login.loginPage.addPersonalInfo'),"has-back":true},on:{"back":_vm.back},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('PersonalInfo',{ref:"form",tag:"component"})]},proxy:true}])})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }